/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1760
 */

"use strict"

var r = require(/* 1100 */"../1767/1100");
(0, require(/* 257 */"../1754/257/index").exportTypedArrayStaticMethod)("from", require(/* 1278 */"./1278"), r)
